import { render, staticRenderFns } from "./ABCGolFormType.vue?vue&type=template&id=612532e5&"
import script from "./ABCGolFormType.vue?vue&type=script&lang=js&"
export * from "./ABCGolFormType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports